export default __webpack_public_path__ + "static/media/Stage_title.3921c280.png";